// 上报页面类型
export enum SLSEventPage {
  /** 充值活动页 */
  ActivityRecharge = 'activity_recharge',
  /** 留言板(斋月活动) */
  ActivityMessageBoard = 'activity_messageBoard',
  /** 注册页 */
  Register = 'register'
}

// 上报事件
export enum SLSEventName {
  /** 活动页渲染完成 */
  LoadActivityPageComplete = 'load_activity_page_complete',
  /** 充值活动页点击充值按钮 */
  ClickActivityPageRechargeBtn = 'click_activity_page_recharge_btn',
  /** 选择充值方式弹窗- 点击去app内充值按钮时上报 */
  ClickActivityPopEndRechargeBtn = 'click_activity_pop_end_recharge_btn',
  /** 选择充值方式弹窗- 点击官网充值充值按钮时上报 */
  ClickActivityPopWebRechargeBtn = 'click_activity_pop_web_recharge_btn',

  /** 留言板活动h5页面渲染成功 */
  MessageBoardShow = 'messageBoard_show',
  /** 留言板活动h5页面tab点击 */
  MessageBoardClickTab = 'messageBoard_click_tab',
  /** 点击留言者头像时候 */
  MessageBoardClickAvatar = 'messageBoard_click_avatar',
  /** 对留言进行点赞时候 */
  MessageBoardClickLikeMessage = 'messageBoard_click_likeMessage',
  /** 成为热门留言的时候 */
  MessageBoardResultHotMessage = 'messageBoard_result_hotMessage',
  /** 点击发布留言按钮时候 */
  MessageBoardClickPostMessageBtn = 'messageBoard_click_postMessageBtn',
  /** 成功进入编辑留言界面的时候 */
  MessageBoardShowInputMessagePage = 'messageBoard_show_inputMessagePage',
  /** 删除留言的时候 */
  MessageBoardClickDeleteMessage = 'messageBoard_click_deleteMessage',
  /** 退出活动界面的时候 */
  MessageBoardClickQuit = 'messageBoard_click_quit',
  /** 留言板活动h5页面滑动最新留言列表 */
  MessageBoardSlideLatestTab = 'messageBoard_slide_latestTab',
  /** 留言板活动h5页面滑动热门留言列表 */
  MessageBoardSlideHotTab = 'messageBoard_slide_hotTab',
  /** 账号反馈-页面曝光 */
  LoginShowFeedback = 'login_show_feedback_h5',
  /** 账号反馈-页面点击提交 */
  LoginClickSubmitFeedback = 'login_click_submit_feedback_h5',
  /** 账号反馈-页面提交结果 */
  LoginResultSubmitFeedback = 'login_result_submit_feedback_h5',
  /** 登录页智能客服-人工客服按钮点击 */
  LoginClickAiCustomerHuman = 'login_click_ai_customer_human',
}
